import { createSelector } from 'reselect'
import getReminderPostSampleSurveySelect from 'modules/post-sample-survey/redux/selectors/get-reminder'
import shouldShowBannerPostSampleSurveySelectUtil from 'modules/post-sample-survey/redux/selectors/should-show-banner/utils'
import isInGiftingModeGiftSelect from 'modules/gift/redux/selectors/is-in-gifting-mode'
import isGiftOrSelfGiftingUrlLocationUtil from 'utils/location/is-gift-or-self-gifting'
import isHomeUrlLocationUtil from 'utils/location/is-home-url'
import isMixedCollectionUrlLocationUtil from 'utils/location/is-mixed-collection-url'
import hasOngoingDealsAppSelect from 'modules/app/redux/selectors/has-ongoing-deals'
import shouldShowUnlockedExtraFreeSamplesBannerCartSelect from 'containers/UnlockedExtraFreeSamplesBanner/selectors/should-show'
import { isReadyCartSelect } from 'modules/cart/redux/selectors/is-ready'
import { shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelector } from 'containers/SpendMoreToUnlockExtraFreeSamples/components/Banner/selectors/should-show'

const shouldShowBannerPostSampleSurveySelect = createSelector(
  getReminderPostSampleSurveySelect,
  isInGiftingModeGiftSelect,
  hasOngoingDealsAppSelect,
  shouldShowUnlockedExtraFreeSamplesBannerCartSelect,
  shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelector(),
  isReadyCartSelect,
  (
    reminder,
    isInGiftingMode,
    hasOngoingDeals,
    shouldShowUnlockedExtraFreeSamplesBanner,
    shouldShowSpendMoreToUnlockExtraFreeSamplesBanner,
    isCartReady
  ) => shouldShowBannerPostSampleSurveySelectUtil({
    reminder,
    isInGiftingMode,
    isCartReady,
    shouldShowSpendMoreToUnlockExtraFreeSamplesBanner,
    isGiftOrSelfGiftingUrl: isGiftOrSelfGiftingUrlLocationUtil(),
    isMixedCollectionUrl: isMixedCollectionUrlLocationUtil(),
    isHomeUrl: isHomeUrlLocationUtil(),
    hasOngoingDeals,
    shouldShowUnlockedExtraFreeSamplesBanner
  })
)

export default shouldShowBannerPostSampleSurveySelect
